import PropTypes from 'prop-types';
import ChipsList from 'components/molecules/ChipsList';
import SelectV2 from 'components/atoms/Select';
import { ReactComponent as Delete } from 'assets/images/delete.svg';
import { getDayHourPerHalf } from 'utils';

import {
  Wrapper,
  SelectWrapper,
  SelectDivider,
  DeleteIcon,
  ExceptionCHipWrapper,
} from '../TimeConfigs/styled';
import { CreateLink } from '../../user/MenuItem/styled';

const ExceptionConfigs = ({
  onSelect,
  errors,
  onSelectTime,
  data,
  onClickDelete,
  onClickCreate,
  selectedDay,
  uuid,
}) => {
  const hours = getDayHourPerHalf();

  const selectedValues = {
    on: data?.hasOwnProperty('day_off') && data?.day_off,
    off: data?.hasOwnProperty('day_off') && !data?.day_off,
  };

  const showOpeningTimes = selectedValues.off;
  const showCreatePause =
    showOpeningTimes &&
    data.hasOwnProperty('break_from') &&
    data.break_from === null &&
    data.hasOwnProperty('break_to') &&
    data.break_to === null;

  const showPauseTimes =
    showOpeningTimes &&
    data.hasOwnProperty('break_from') &&
    data.break_from !== null &&
    data.hasOwnProperty('break_to') &&
    data.break_to !== null;

  return (
    <Wrapper variant='exception'>
      <ExceptionCHipWrapper>
        <ChipsList
          list={[{ id: 'day_off-off', title: 'Aperto' }]}
          onClick={(d) => onSelect({ ...d, uuid }, data)}
          selectedList={selectedValues.off ? ['day_off-off'] : []}
          onlyNative={true}
          name='day_off-off'
          error={errors?.base}
        />
        {showOpeningTimes && (
          <DeleteIcon
            variant='exception'
            role='presentation'
            onClick={() => onClickDelete({ id: 'day_off', uuid })}
          >
            <Delete />
          </DeleteIcon>
        )}
      </ExceptionCHipWrapper>
      <div style={{ marginTop: 20 }}>
        {showOpeningTimes && (
          <SelectWrapper pr={30}>
            <SelectV2
              desktopMb={0}
              fullWidth={true}
              label='Inizio'
              onChange={e => onSelectTime(e, data)}
              name='from'
              items={hours}
              selectedKey={data?.from}
              error={errors?.from}
            />
            <SelectDivider>—</SelectDivider>
            <SelectV2
              desktopMb={0}
              fullWidth={true}
              label='Fine'
              onChange={e => onSelectTime(e, data)}
              name='to'
              items={hours}
              selectedKey={data?.to}
              error={errors?.to}
            />
          </SelectWrapper>
        )}
        { showPauseTimes && (
          <div style={{ marginTop: 12 }}>
            <p>Pause</p>
            <SelectWrapper pr={30}>
              <SelectV2
                desktopMb={0}
                fullWidth={true}
                label='Inizio'
                onChange={e => onSelectTime(e, data)}
                name='break_from'
                items={hours}
                selectedKey={data?.break_from}
                error={errors?.break_from}
              />
              <SelectDivider>—</SelectDivider>
              <SelectV2
                desktopMb={0}
                fullWidth={true}
                label='Fine'
                onChange={e => onSelectTime(e, data)}
                name='break_to'
                items={hours}
                selectedKey={data?.break_to}
                error={errors?.break_to}
              />
              <DeleteIcon
                role='presentation'
                onClick={() => onClickDelete({ id: 'pause', selectedDay, data })}
              >
                <Delete />
              </DeleteIcon>
            </SelectWrapper>
          </div>
        ) }
        {showCreatePause && (
          <CreateLink
            style={{ padding: '0 30px', textAlign: 'right', display: 'block' }}
            as='span'
            role='presentation'
            onClick={() =>
              onClickCreate({
                // id: item.id,
                key: 'pause',
                data,
              })
            }
          >
            + Aggiungi pausa
          </CreateLink>
        )}
      </div>
      <ExceptionCHipWrapper style={{ marginTop: 40 }}>
        <ChipsList
          list={[{ id: 'day_off-on', title: 'Chiuso' }]}
          onClick={(d) => onSelect({ ...d, selectedDay }, data)}
          selectedList={selectedValues.on ? ['day_off-on'] : []}
          onlyNative={true}
          name='day_off-on'
          error={errors?.base}
        />
        {/*<DeleteIcon
          variant='exception'
          role='presentation'
          onClick={() => onClickDelete({ id: 'day_off', key: 'first' })}
        >
          <Delete />
        </DeleteIcon>*/}
      </ExceptionCHipWrapper>
    </Wrapper>
  );
};

ExceptionConfigs.propTypes = {
  onSelect: PropTypes.func,
  selected: PropTypes.any,
  errors: PropTypes.any,
  onSelectTime: PropTypes.func,
  itemData: PropTypes.shape({}),
  onClickDelete: PropTypes.func,
};

export default ExceptionConfigs;
